<template>
  <div>
    <p>{{ printDate(stat.date, 'DD.MM.YYYY')}}</p>
    <p>спрос: <strong>{{ stat.call ?? 0 }}</strong></p>
    <p>цена: <strong>{{ stat.price ?? 0 }}</strong></p>
    <p>наличие: <strong>{{ stat.stores ?? 0 }}</strong></p>
    <p>потенциал: <strong>{{ Math.round(stat.potential / 1000).toLocaleString('ru-RU') }}k</strong></p>
  </div>
</template>

<script>

export default {
  props: ['stat']
}

</script>
